const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkipIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2029"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1014",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z",
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9120"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "m0 1.423 2.583 2.584L0 6.591l1.423 1.423 3.572-3.572-.011-.011.459-.459-.712-.712-.023.023L1.423 0z",
    transform: "translate(7 8)",
    style: {
      fill: "#363e50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26480",
    d: "M18.41 6h-2v8.014h2z",
    transform: "translate(-1.41 2)",
    style: {
      fill: "#363e50"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipIcon);
export default __webpack_public_path__ + "static/media/skip-icon.82ec0e46d36028e81f181e43e17339ff.svg";
export { ForwardRef as ReactComponent };